import { render, staticRenderFns } from "./Inspirations.vue?vue&type=template&id=0acce320&"
import script from "./Inspirations.vue?vue&type=script&lang=js&"
export * from "./Inspirations.vue?vue&type=script&lang=js&"
import style0 from "./Inspirations.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports